import config from 'config';
import resolveSlugHref from 'utils/resolveSlugHref';

const { routes } = config;

const getCategoryHref = (slug?: string, prefix?: string): string | undefined =>
  slug ? resolveSlugHref({ pathname: `${prefix || ''}${routes.category.slug.href}`, query: { slug } }) : undefined;

export default getCategoryHref;
